(function () {
    'use strict';

    angular
        .module('wizard-future7.services')
        .service('NotifyService', NotifyService)

    /** @ngInject */
    function NotifyService(sweetAlert) {
        const NotifyService = {
            notify,
            success,
            error,
            warning
        };

        return NotifyService;

        function notify(config, callback, errCallback) {
            sweetAlert.swal(config).then(callback).catch(errCallback);
        }

        function success(title = 'SUCESSO!', message) {
            notify({
                title: title,
                type: 'success',
                text: message
            });
        }

        function error(title = 'ERRO!', message) {
            notify({
                title: title,
                type: 'error',
                text: message
            });
        }

        function warning(title = 'ATENÇÃO!', message) {
            notify({
                title: title,
                type: 'warning',
                text: message
            });
        }
    }
}());